<template>
  <div class="mb16">

    <Modal v-model="pwdModal" :mask-closable="maskClose" @on-ok="ok" :loading="loading" @on-cancel="cancel">
      <h3 slot="header" class="modal-header">获取密码</h3>
      <Form :label-width="100" ref="formData" :rules="formRules" :model="formData">
        <FormItem label="使用人类型" prop="userType">
          <RadioGroup v-model="formData.userType" @on-change="changeType">
            <Radio v-for="item in userTypeList" :label="item.value" :key="item.value">{{item.text}}</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="系统号" prop="userCode" v-if="formData&&formData.userType==1">
          <Input class="input-width" style="display: inline-block" v-model="formData.userCode" @on-blur="searchUser"/>
          <span :class="['lin32', 'text-red',{'not-exit':notShow}]">该用户不存在</span>
        </FormItem>
        <FormItem label="使用人" prop="userName">
          <Input class="input-width" v-model="formData.userName" :disabled="formData.userType===1"/>
        </FormItem>
        <FormItem label="手机号" prop="phone">
          <Input class="input-width" v-model="formData.phone" :disabled="formData.userType===1"/>
        </FormItem>
        <FormItem label="密码有效时间" prop="effectiveTime">
          <Select class="short-width" v-model="formData.effectiveTime">
            <Option v-for="item in pwdEffectiveTimeList" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
        </FormItem>
        <FormItem label="自定义密码" prop="pwd">
          <Input class="short-width" v-model="formData.pwd" :disabled="pwdDisable"/>
          <span class="lin32 text-blue" @click.stop="generatePwd">生成随机数</span>
          <span class="lin32 text-blue" @click.stop="clearPwd">清除</span>
        </FormItem>
      </Form>
      <Row class="mb16">
        <Col class="text-red" offset="5">
          注1：如自定义密码为空，会由系统随机生成6位随机数 <br>
          注2：如果使用人已经有房间密码，新密码会替换旧密码
        </Col>
      </Row>
    </Modal>
  </div>
</template>

<script>
  import {getEmployeeByCode} from "api/common";
  import {pwdEffectiveTime} from "api/getPassword";
  import {deepClone} from "../../../../utils/format";
  // import {}

  export default {
    // name: "GetPasswordModal",
    props: {
      n: {
        type: Number,
        default: 0
      },
      userTypeList: {
        type: Array,
        default: null
      },
      pwdEffectiveTimeList: {
        type: Array,
        default: null
      },
      reset: {
        type: Boolean,
        default: false

      },
      lockNum: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        maskClose: false,
        formData: {
          userType: 1,   //1 :内部员工 2：第三方
          userName: '',
          effectiveTime: 3,
          pwd: '',
          userCode: '',
          phone: '',
        },
        loading: true,
        pwdDisable: true,
        pwdModal: false,
        notShow: true,
        pwdEffectiveTimeList2: deepClone(this.pwdEffectiveTimeList),

        pwdWarnNotShow: true

      }
    },
    computed: {
      formRules() {
        return {
          userType: [{required: true, trigger: 'change', message: '', type: 'number'}],
          userCode:
            [
              {required: true, message: '请填写系统号', trigger: 'blur', type: 'string'}
            ],
          userName:
            [
              {required: true, message: '请填写使用人', trigger: 'change', type: 'string'}
            ],
          phone:
            [
              {required: true, validator: this.validatecontactPhone, trigger: 'change', message: '请填写正确的手机号'}
            ],
          effectiveTime:
            [
              {required: true, trigger: 'change', message: '', type: 'number'}
            ],
          pwd: [
            {required: this.lockNum > 1 ? true : false, trigger: 'change', message: '自定义密码不能为空', type: 'string'}
          ]
        }
      }
    },

    watch: {
      n() {
        this.resetformData()
        this.pwdModal = true
      }
    },
    methods: {
      resetformData() {
        this.formData.userType = 1
        this.formData.userName = ''
        this.formData.effectiveTime = 3
        this.formData.pwd = ''
        this.formData.userCode = ''
        this.formData.phone = ''
        this.$refs['formData'].resetFields()
        this.notShow = true
      },
      validatecontactPhone(rule, value, callback) {
        let pattern = /^1(\d+){10}$/
        if (!pattern.test(value)) {
          callback(new Error('输入正确的联系方式'));
        }
        callback();
      },

      cancel() {
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        this.$refs['formData'].validate(bool => {
          if (bool) {
            this.$emit('getpassword', this.formData)
            this.pwdModal = false
            this.$emit('clearTable')
          }
          else {
            this.changeLoading()
          }
        })
      },
      changeType(data) {

        this.$refs['formData'].resetFields()
        this.formData.userType = data
        this.formData.pwd = ''
        this.formData.userCode = ''
        this.formData.userName = ''
        this.formData.phone = ''
        this.notShow = true
        this.$emit('changeusertype', data)
      },
      searchUser() {
        if (this.formData.userType == 2 || this.formData.userCode == '') {
          return
        }
        let params = {
          code: this.formData.userCode
        }
        getEmployeeByCode(params).then(res => {
          this.formData.userName = res.data.employeeName
          this.formData.phone = res.data.employeeMobile
          this.notShow = true
        }).catch(err => {
          this.notShow = false
          this.formData.userName = ''
          this.formData.phone = ''
        })
      },
      generatePwd() {
        var ret = ''
        for (let i = 0; i < 6; i++) {
          ret += Math.floor(Math.random() * 10)
        }
        this.formData.pwd = ret
      },
      clearPwd() {
        this.formData.pwd = ''
      }

    }
  }
</script>

<style scoped>
  .short-width {
    width: 100px;
  }

  .input-width {
    width: 220px;
  }

  .not-exit {
    display: none;
  }

  .text-right {
    text-align: right;
  }

  .text-red {
    color: red;
    font-weight: bold;
  }

  .lin32 {
    line-height: 32px;
  }

  .text-blue {
    color: rgb(80, 153, 247);
    font-weight: bold;
  }


</style>
